<template>
  <!--begin::App-->
  <div class="app-root" id="kt_app_root">
    <!--begin::Page-->
    <div class="app-page" id="kt_app_page">
      <div class="registration h-100 p-4">
        <div class="container h-100">
          <div class="d-flex flex-column flex-lg-row justify-content-lg-between bg-white br-40 h-100">
            <div class="col-12 col-lg-6 order-1 order-lg-0">
              <div class="d-flex flex-column justify-content-center h-100 p-10">
                <!-- REGISTRATION FORM -->
                <template v-if="localStep === 'registration'">
                  <router-link class="logo" :to="'/'">
                    <img src="/images/layout/logo-pixel-principal.png" alt="Pixel Roads" class="mb-5"/>
                  </router-link>
                  <h1 class="font3 font-size-large font-size-md-xxLarge fw-300">
                    {{ $t('the') }} <span class="fw-700">{{ $t('right_ad') }}</span> {{ $t('right') }}<br>
                    {{ $t('at_the_ideal_time') }}
                  </h1>
                  <form @submit.prevent="submit" class="default-form" ref="authForm">
                    <div class="d-flex flex-column flex-md-row justify-content-center align-items-end gap-md-7">
                      <div class="form-group col-12 flex-md-fill mb-3">
                        <label class="form-label fw-bold font3 font3">{{ $t('country') }}*</label>
                        <div class="custom-select">
                          <select class="form-control  form-control-sm" v-model.trim="$v.form.country.$model">
                            <option disabled selected value="">{{ $t('select') }}</option>
                            <option v-for="(country, index) in parsedCountries" :key="index" :value="country.code">{{ country.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group col-12 flex-md-fill mb-3">
                        <label class="form-label fw-bold font3">{{ $t('language') }}*</label>
                        <div class="custom-select">
                          <select class="form-control  form-control-sm" v-model.trim="$v.form.language.$model">
                            <option disabled="true" selected="true" value="">{{ $t('select') }}</option>
                            <option v-for="(language, index) in availableLanguages" :key="index" :value="language">{{ $t('languages.'
                              + language) }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-center align-items-end gap-md-7">
                      <div class="form-group col-12 flex-md-fill mb-3">
                        <label class="form-label fw-bold font3">{{ $t('full_name') }}*</label>
                        <input type="text" class="form-control  form-control-sm" :placeholder="$t('full_name')" v-model.trim="$v.form.name.$model" />
                      </div>
                      <div class="form-group col-12 flex-md-fill mb-3">
                        <label class="form-label fw-bold font3">{{ $t('phone') }}*</label>
                        <PhoneInput v-model.trim="$v.form.phone.$model" :country="form.country" />
                      </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-center align-items-end gap-md-7">
                      <div class="form-group col-12 flex-md-fill mb-3">
                        <label class="form-label fw-bold font3">{{ $t('email') }}*</label>
                        <input type="email" class="form-control  form-control-sm" :placeholder="$t('enter_your_email')"
                          v-model.trim="$v.form.email.$model" />
                      </div>
                      <div class="form-group col-12 flex-md-fill mb-3">
                        <label class="form-label fw-bold font3">{{ $t('confirm_email') }}*</label>
                        <input type="email" class="form-control  form-control-sm" :placeholder="$t('enter_your_email')"
                          v-model.trim="$v.form.email_confirmation.$model" />
                      </div>
                    </div>
                    <!-- MESSAGES -->
                    <div class="mb-2 alert alert-danger font-size-xSmall px-3 py-2"
                      v-if="!isEmailInputConfirmed && form.email && form.email_confirmation">
                      <p class="mb-0">
                        {{ $t('email_addresses_must_match') }}
                      </p>
                    </div> <!-- END MESSAGES -->
                    <div class="d-flex flex-column flex-md-row justify-content-center align-items-end gap-md-7">
                      <div class="form-group col-12 flex-md-fill mb-3 position-relative">
                        <label class="form-label fw-bold font3">{{ $t('password') }}*</label>
                        <input :type="showPassword ? 'text' : 'password'" class="form-control  form-control-sm" :placeholder="$t('enter_your_password')"
                        v-model.trim="$v.form.password.$model" autocomplete="new-password" />
                        <i
                          class="fa"
                          :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                          @click="showPassword = !showPassword"
                        ></i>
                      </div>
                      <div class="form-group col-12 flex-md-fill mb-3 position-relative">
                        <label class="form-label fw-bold font3">{{ $t('confirm_password') }}*</label>
                        <input :type="showPasswordConfirmation ? 'text' : 'password'" class="form-control  form-control-sm" :placeholder="$t('confirm_password')"
                          v-model.trim="$v.form.password_confirmation.$model" autocomplete="new-password" />
                          <i
                            class="fa"
                            :class="showPasswordConfirmation ? 'fa-eye-slash' : 'fa-eye'"
                            @click="showPasswordConfirmation = !showPasswordConfirmation"
                          ></i>
                      </div>
                    </div>
                    <div class="form-group mb-3" v-if="1 == 2">
                      <label class="form-label fw-bold font3">{{ $t('indication_code') }}</label>
                      <input type="text" class="form-control  form-control-sm" placeholder="" v-model.trim="form.referral_code" />
                    </div>
                    <div class="mt-4">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="checkbox" v-model.trim="$v.form.terms.$model" id="terms">
                        <label class="form-check-label" for="terms">{{ $t('i_have_read_and_agree_to_the') }} <router-link
                            :to="{ name: 'statics.terms' }" target="_blank" class="link-color5">{{ $t('terms_of_use_and_privacy_policy')
                            }}</router-link>.</label>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <Button type="submit" class="btn-color5 w-100" :disabled="$v.$invalid || !isEmailInputConfirmed"
                        :loading="loader">
                        {{ $t('create_account') }}
                      </Button>
                    </div>
                  </form>
                </template> <!-- END REGISTRATION FORM -->

                <!-- CONFIRMATION FORM -->
                <template v-if="localStep === 'verification'">
                  <div class="text-center">
                    <img src="/images/layout/logo-pixel-principal.png" alt="Pixel Roads" class="w-250px mb-10" />
                    <br>
                    <img src="/images/v2/layout/icon-check.png" alt="Pixel Roads" class="icon mb-5" />
                    <h2 class="fw-light font3 w-sm-50 mx-auto">
                      <span class="fw-500">{{ $t('success') }}!</span> {{ $t('your_account_has_been_successfully') }}
                    </h2>
                    <div class="fw-500 mt-4 pb-5">
                      <p class="">
                        {{ $t('we_send_a_code_to') }} {{ confirmationEmail }}
                      </p>
                    </div>
                    <form @submit.prevent="verify" class="text-center default-form">
                      <div class="form-group w-sm-75 mx-auto">
                        <label class="form-label fw-bold font3">{{ $t('enter_the_code_sent') }}</label>
                        <input type="text" class="form-control  form-control-sm" v-model.trim.trim="$v.confirmation.code.$model" placeholder="" />
                      </div>
                      <Button type="submit" class="btn-color5 my-3 w-sm-75 mx-auto" :disabled="$v.$invalid" :loading="loader">
                        {{ $t('confirm') }}
                      </Button>
                      <p class="font-size-small mt-2 w-sm-75 mx-auto">{{ $t('code_may_be_in_your_spam_folder') }}</p>
                      <div class="text-center mt-3">
                        {{ $t('didnt_receive_it') }}
                        <a href="#" @click.prevent="reSendCode" class="mb-3 link-color5">
                          <template v-if="isResendingCode">
                            <Loader :size="'small'" :align="'start'" />
                          </template>
                          <template v-else>
                            {{ $t('send_code_again') }}
                          </template>
                        </a>
                      </div>
                    </form>
                  </div>
                </template> <!-- END CONFIRMATION FORM -->
              </div>
            </div>
            <div class="col-12 col-lg-6 order-0 order-lg-1 d-none d-lg-block position-relative text-end login-image">
              <div class="h-100">
                <div class="position-absolute w-100 d-flex justify-content-end">
                  <select v-model="$i18n.locale" id="language" class="form-select font-size-small border-0 w-auto" @change="handleLanguageChange">
                    <option value="pt_BR">PT</option>
                    <option value="en" selected>EN</option>
                    <option value="es">ES</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TheFooter />
    </div>
    <!--end::Page-->
  </div>
  <!--end::App-->
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import UsersService from '@/modules/users/services/users-service'
import { required, email } from 'vuelidate/lib/validators'
import variables from '@/mixins/variables'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import PhoneInput from '@/components/common/Input/PhoneInput'
import TheFooter from '@/components/footers/TheFooter2'

export default {
  name: 'Registration',
  mixins: [variables],
  components: {
    Loader,
    Button,
    PhoneInput,
    TheFooter
  },
  data () {
    return {
      loader: false,
      localStep: 'registration',
      confirmation: {
        code: '',
        email: ''
      },
      isResendingCode: false,
      form: {
        name: '',
        email: '',
        email_confirmation: '',
        password: '',
        password_confirmation: '',
        phone: '',
        language: '',
        country: '',
        terms: ''
      },
      showPassword: false,
      showPasswordConfirmation: false
    }
  },
  metaInfo () {
    return {
      title: this.localStep === 'registration' ? this.$t('registration') : this.$t('confirmation')
    }
  },
  validations () {
    if (this.localStep === 'registration') {
      const obj = {
        form: {
          name: { required },
          email: { required, email },
          email_confirmation: { required, email },
          password: { required },
          password_confirmation: { required },
          phone: { required },
          language: { required },
          country: { required },
          terms: { required }
        }
      }
      return obj
    } else if (this.localStep === 'verification') {
      return {
        confirmation: {
          code: { required }
        }
      }
    }
    return {}
  },
  created () {
    this.handleLanguage()

    if (this.registrationStep) this.localStep = this.registrationStep
    if (this.userEmail) this.confirmation.email = this.userEmail

    window.dataLayer.push({
      event: 'reg-init',
      event_category: 'open-page',
      event_label: 'Cadastre-se agora!'
    })

    // Checks for referral code
    const code = window.localStorage.getItem('referral')
    if (code) {
      this.form.referral_code = code
    } else {
      this.form.referral_code = ''
    }
    this.detectLocation()
    // Disable copy paste
    this.disableCopyPaste()
  },
  watch: {
    step (newStep) {
      this.localStep = newStep
    },
    userEmail (email) {
      this.confirmation.email = email
    }
  },
  computed: {
    ...mapState('auth', ['registrationStep', 'userEmail']),
    confirmationEmail () {
      return this.userEmail ?? this.confirmation.email
    },
    /**
     * Check if emails inputs are equal
     */
    isEmailInputConfirmed () {
      return this.form.email === this.form.email_confirmation
    },
    /**
     * parse countries list
    */
    parsedCountries () {
      const countries = this.countries.map(item => {
        return {
          code: item,
          name: this.$t(`countries_names.${item}`)
        }
      })

      countries.sort((a, b) => a.name.localeCompare(b.name))

      // Puts Brazil at the top of the list
      const indexBrasil = countries.findIndex(country => country.code === 'BR')
      if (indexBrasil !== -1) {
        const brasil = countries.splice(indexBrasil, 1)[0]
        countries.unshift(brasil)
      }

      return countries
    }
  },
  methods: {
    async handleLanguage () {
      const language = await UsersService.getCookie('user_language')
      if (language) {
        this.$i18n.locale = language
      } else {
        await UsersService.setCookie('user_language', 'pt_BR', 30)
        this.$i18n.locale = 'pt_BR'
      }
    },
    async handleLanguageChange () {
      await UsersService.setCookie('user_language', this.$i18n.locale, 30)
    },
    /**
     * Disable copy paste
     */
    disableCopyPaste () {
      // Prevent ctrl c + ctrl v
      this.$nextTick(() => {
        if (this.$refs.authForm) {
          this.$refs.authForm.addEventListener('copy', (event) => {
            event.clipboardData.setData('text/plain', '')
            event.preventDefault()
          })
        }
      })
    },
    /**
     * Remove disable copy and paste
     */
    removeDisableCopy () {
      // Remove listener to prevent ctrl + c
      this.$refs.authForm.removeEventListener('copy', this.disableCopyPaste)
    },
    /**
     * Resend code
     */
    async reSendCode () {
      this.isResendingCode = true
      try {
        await AuthService.resendConfirmationCode({ email: this.confirmation.email })
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('info_new_code_2fa')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.isResendingCode = false
    },
    /**
     * Reset form
     */
    reset () {
      this.localStep = 'registration'
    },
    /**
     * Submit registration form
     */
    async submit () {
      this.loader = true
      try {
        const urlParams = new URLSearchParams(window.location.search)
        const utmData = {
          utm_source: urlParams.get('utm_source') || null,
          utm_medium: urlParams.get('utm_medium') || null,
          utm_id: urlParams.get('utm_id') || null,
          utm_campaign: urlParams.get('utm_campaign') || null,
          utm_term: urlParams.get('utm_term') || null,
          utm_content: urlParams.get('utm_content') || null
        }
        const form = Object.assign({}, this.form, { utm_data: utmData })
        form.responsible = urlParams.get('responsible') || null
        form.phone = form.phone.replace('+', '').replace(/\s/g, '')
        const response = await AuthService.register(form)
        this.confirmation.email = response.email
        this.localStep = 'verification'
        window.localStorage.removeItem('referral')
        window.dataLayer.push({
          event: 'reg-finish',
          event_category: 'form',
          event_label: 'Cadastrar'
        })
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Send verification code for validation
     */
    async verify () {
      this.loader = true
      try {
        await AuthService.verifyEmail({
          code: this.confirmation.code,
          email: this.confirmationEmail
        })
        location.reload()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    async detectLocation () {
      try {
        const response = await fetch('https://ipapi.co/json/')
        const data = await response.json()

        if (data.country_code) {
          this.form.country = data.country_code
        }

        // Define idioma padrão
        switch (data.country_code) {
          case 'BR':
            this.form.language = 'pt_BR'
            break

          case 'ES':
          case 'MX':
          case 'AR':
          case 'CL':
          case 'CO':
          case 'PE':
            this.form.language = 'es'
            break

          default:
            this.form.language = 'en'
        }
      } catch (e) {
        this.form.country = 'BR'
        this.form.language = 'pt_BR'
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .logo {
    img {
      width: 150px;
    }
  }

  .icon {
    width: 100px;
    @include tablet {
      width: 150px;
    }
  }

  .app-page {
    flex-direction: column;
    overflow: hidden;
    background: #F8F9FA;
  }

  .app-root, .app-page {
    @media (min-height: 868px) {
      height: 100%;
    }

    @media (min-height: 1200px) {
      height: auto;
    }
  }

  .registration {
    background: #ECD263;
  }

  .login-image {
    border-radius: 0 0 40px 0;
    max-height: 100%;
    background: url('/images/v2/layout/image-login.jpg') no-repeat;
    background-size: cover;
  }

  .fa {
    position:absolute;
    right: 12px;
    top: 60%;
    cursor:pointer;
  }
</style>
